import HCRender from "../hc-render"
import Typography from "aldoo-ra/Typography"

const MainContent = ({
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  const PulsingLoader = HCRender.getFragment("PulsingLoader")
  const ArticleContent = HCRender.getFragment("ArticleContent")
  const CategoryContent = HCRender.getFragment("CategoryContent")

  return (
    <div className="w-full lg:w-4/5 lg:ml-14 mx-auto lg:mx-0">
      <div>
        {isLoading ? (
          <div className="flex justify-center items-center h-40">
            {PulsingLoader && <PulsingLoader />}
          </div>
        ) : error ? (
          <div className="border border-red-200 rounded p-4">
            <Typography variant="error">{error}</Typography>
          </div>
        ) : contentType === "article" ? (
          ArticleContent && (
            <ArticleContent article={selectedContent} onFeedback={onFeedback} />
          )
        ) : (
          CategoryContent && (
            <CategoryContent category={selectedContent} onNavigate={navigateTo} />
          )
        )}
      </div>
    </div>
  )
}

export default MainContent
